<app-navtop></app-navtop>
<app-navside-apps-list></app-navside-apps-list>

<div class="container-fluid pt-5">
  <div class="d-flex justify-content-end"> 
    <div class="col-xl-9 col-lg-9 col-md-8 p-2">
    
      <div class="row">            
        <!-- Top Slideshow -->
        <div class="col-12"> 
          <div class="card my-3">
            <div id="carouselExampleControls2" class="carousel slide" data-ride="carousel">
              <div class="carousel-inner">
                <ng-container *ngFor="let doc of pictureCol | async; index as i; first as isFirst; last as isLast">        
                  <div [ngClass]="isFirst ? 'carousel-item active' : 'carousel-item' ">
                    <div class="">
                      <img [src]="doc.pictureUrl" class="card-img-top" style="height: 12rem;" alt="...">
                    </div>
                  </div>  
                </ng-container>
              </div>
              <a class="carousel-control-prev" href="#carouselExampleControls2" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#carouselExampleControls2" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>
          </div> 
        </div>

        <!-- left column - Package Details -->        
        <div class="col-xl-6 col-lg-6 col-md-12">
          <div class="card mx-auto my-3 shadow-lg">                                           
            <div class="card-body">
              <h2>Tour Package Details</h2>
              <ul class="list-group list-group-flush">
                <li class="list-group-item font-weight-bold">{{(tourpackageDoc | async)?.name}}</li>
                <li class="list-group-item" *ngIf="(tourpackageDoc | async)?.price">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cash" viewBox="0 0 16 16">
                    <path d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>
                    <path d="M0 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V6a2 2 0 0 1-2-2H3z"/>
                  </svg>
                  {{(tourpackageDoc | async)?.price | currency: 'K'}}
                </li>
                <li class="list-group-item">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-week" viewBox="0 0 16 16">
                    <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>
                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                  </svg>
                  {{(tourpackageDoc | async)?.duration}} days
                </li>
                <li class="list-group-item">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                    <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
                  </svg>
                  {{(tourpackageDoc | async)?.location}}
                </li>

              </ul>                  
            </div> 
          </div> 
          <div class="card mx-auto my-3 shadow-lg card-sticky">                                           
            <div class="card-body">
              <h2>Tour Operator Details</h2> 
              <ul class="list-group list-group-flush">
                <li class="list-group-item font-weight-bold">
                  <div class="media">                        
                      <img [src]="(tourpackageDoc | async)?.ownerProfilePictureUrl" class="mr-3 align-self-center rounded-circle image" alt="...">
                      <div class="media-body align-self-center">
                        {{(tourpackageDoc | async)?.ownerName}}
                      </div>
                  </div> 
                </li>
                <li class="list-group-item" *ngIf="(tourpackageDoc | async)?.ownerPhone">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                  </svg>
                  +(675)-{{(tourpackageDoc | async)?.ownerPhone}}
                </li>
                <li class="list-group-item" *ngIf="(tourpackageDoc | async)?.ownerEmail">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
                  </svg>
                  {{(tourpackageDoc | async)?.ownerEmail}}</li>
                <li class="list-group-item" *ngIf="(tourpackageDoc | async)?.ownerWebsiteUrl">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-globe" viewBox="0 0 16 16">
                    <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.386.295.744.468 1.068.552 1.035 1.218 1.65 1.887 1.855V12H5.145zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472zM3.82 11a13.652 13.652 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5H3.82zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933zM8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855.173-.324.33-.682.468-1.068H8.5zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5a6.959 6.959 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5h2.49zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4a7.966 7.966 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4h2.355z"/>
                  </svg>
                  {{(tourpackageDoc | async)?.ownerWebsiteUrl}}
                </li>
                <li class="list-group-item" *ngIf="(tourpackageDoc | async)?.ownerWebsiteUrl">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-globe" viewBox="0 0 16 16">
                      <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.386.295.744.468 1.068.552 1.035 1.218 1.65 1.887 1.855V12H5.145zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472zM3.82 11a13.652 13.652 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5H3.82zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933zM8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855.173-.324.33-.682.468-1.068H8.5zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5a6.959 6.959 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5h2.49zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4a7.966 7.966 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4h2.355z"/>
                  </svg>
                  <a [href]="(tourpackageDoc | async)?.ownerWebsiteUrl" target="_blank" class="text-primary"> {{(tourpackageDoc | async)?.ownerWebsiteUrl}}                            
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up-right font-weight-bold" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/>
                          <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/>
                      </svg>                                 
                  </a>
              </li>
              </ul>                  
            </div> 
          </div>                              
        </div>

        <!-- right column - Package Details -->
        <div class="col-xl-6 col-lg-6 col-md-12"> 
          <div class="card mx-auto my-3 shadow-lg">                                           
            <div class="card-body">
              <h2>Overview</h2> 
              <ul class="list-group list-group-flush">
                <li class="list-group-item" *ngIf="(tourpackageDoc | async)?.overview">
                    {{(tourpackageDoc | async)?.overview}}                                     
                </li>
              </ul>                
            </div>
          </div>
          <!-- Admins-->
          <!-- <div class="card mx-auto my-3 shadow-lg">                                           
            <div class="card-body">
              <h2>Admins</h2> 
              <ul class="list-group list-group-flush">
                <li class="list-group-item" *ngFor="let admin of (tourpackageDoc | async)?.admins | keyvalue">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="currentColor" class="bi bi-check2-circle text-success" viewBox="0 0 16 16">
                        <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/>
                        <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/>
                    </svg>  
                    {{admin.value.name}}                                          
                </li> 
              </ul>                
            </div> 
          </div>     -->
          <!-- Inclusions -->
          <div class="card mx-auto my-3 shadow-lg">                                           
            <div class="card-body">
              <h2>Inclusions</h2> 
              <ul class="list-group list-group-flush">
                <li class="list-group-item" *ngFor="let array of (tourpackageDoc | async)?.inclusions">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="currentColor" class="bi bi-check2-circle text-success" viewBox="0 0 16 16">
                        <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/>
                        <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/>
                    </svg>
                    {{array}}                                     
                </li>
              </ul>                
            </div>
          </div>
          <!-- Exlusions -->
          <div class="card mx-auto my-3 shadow-lg">                                           
            <div class="card-body">
              <h2>Exclusions</h2> 
              <ul class="list-group list-group-flush">
                <li class="list-group-item" *ngFor="let array of (tourpackageDoc | async)?.exclusions">
                    
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle text-danger" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>                  
                    {{array}}                                        
                </li>
              </ul>                
            </div>
          </div>
          <!-- <div class="card mx-auto my-3 shadow-lg">                                           
            <div class="card-body">
              <h2>Cancellation Policy</h2> 
              <ul class="list-group list-group-flush">
                <li class="list-group-item" *ngFor="let array of (tourpackageDoc | async)?.cancellations">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="currentColor" class="bi bi-check2-circle text-success" viewBox="0 0 16 16">
                        <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/>
                        <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/>
                    </svg>                  
                    {{array}}                                          
                </li>
              </ul>                
            </div>
          </div>     -->
          <!-- <div class="card mx-auto my-3 shadow-lg">                                           
            <div class="card-body">
              <h2>Refund Policy</h2> 
              <ul class="list-group list-group-flush">
                <li class="list-group-item" *ngFor="let array of (tourpackageDoc | async)?.refunds">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="currentColor" class="bi bi-check2-circle text-success" viewBox="0 0 16 16">
                        <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/>
                        <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/>
                    </svg>                  
                    {{array}}                                          
                </li>
              </ul>                
            </div>
          </div>           -->
        </div>        
      </div>

      <!-- Itinerary -->
      <div class="row bg-white m-1">   
          <h2 class="m-3 btn btn-block">Itinerary</h2>
          <div class="col-xl-6 col-lg-6 col-md-12" *ngFor="let doc of itineraryCol | async">
            <div class="card mx-auto my-3 shadow-lg border-dark">
              <div class="card-header text-uppercase font-weight-bold bg-dark text-white">
                {{ doc.name }}
              </div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item font-weight-bold bg-light">Day {{ doc.day }}</li>
                <li class="list-group-item">{{ doc.activity }}</li>
              </ul>
            </div>
          </div>

          <!-- <div class="col-xl-6 col-lg-6 col-md-12" *ngFor="let doc of itineraryCol | async">
              <div class="card mx-auto my-3 shadow-lg">                                                                   
                  <div class="card-body">
                      <p class="text-uppercase font-weight-bold">{{ doc.name }}</p> 
                      <p class="">Day {{ doc.day }}</p>
                      <ul class="list-group list-group-flush">
                        <li class="list-group-item">{{ doc.activity }}</li>
                      </ul>                  
                  </div>
              </div>
          </div> -->
      </div>
      
      <!-- Similar Tour Packages -->
      <!-- <div class="row bg-dark m-1 my-3">   
          <h2 class="m-3 btn btn-block text-white">Similar Tour Packages</h2>     
          <div class="col-xl-6 col-lg-6 col-md-12">
              <div class="card mx-auto my-3 shadow-lg">
                  <div class="list-group my-1">
                    <a class="list-group-item list-group-flush border-0" routerLink="">                
                      <div class="media">                        
                        <img [src]="logoImage" class="mr-3 align-self-center rounded-circle image" alt="...">
                        <div class="media-body">
                          <h3>Tour Operator Name</h3>
                          <h5>Date Posted</h5>
                        </div>
                      </div>                
                    </a>   
                  </div>   
                  <div id="carouselExampleControls1" class="carousel slide" data-ride="carousel">
                      <div class="carousel-inner">
                        <div class="carousel-item active">
                          <img [src]="logoImage" class="d-block w-100 card-img-top" alt="...">
                        </div>
                        <div class="carousel-item">
                          <img [src]="coverImage" class="d-block w-100 card-img-top" alt="...">
                        </div>
                        <div class="carousel-item">
                          <img [src]="logoImage" class="d-block w-100 card-img-top" alt="...">
                        </div>
                      </div>
                      <a class="carousel-control-prev" href="#carouselExampleControls1" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                      </a>
                      <a class="carousel-control-next" href="#carouselExampleControls1" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                      </a>
                    </div>
                  <div class="card-body">
                    <h4 class="card-title">Tour Package Name</h4>
                    <div class="row text-danger">
                      <div class="col-lg-4 col-md-12">
                        Duration
                      </div>
                      <div class="col-lg-4 col-md-12">
                        Location
                      </div>
                      <div class="col-lg-4 col-md-12">
                        Price
                      </div>
                    </div>                
                    <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                    <a (click)="routeToDetailPage(2)" routerLink="" class="btn btn-dark text-white">View Details...</a>
                  </div>
                </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12">
              <div class="card mx-auto my-3 shadow-lg">
                  <div class="list-group my-1">
                    <a class="list-group-item list-group-flush border-0" routerLink="">                
                      <div class="media">                        
                        <img [src]="logoImage" class="mr-3 align-self-center rounded-circle image" alt="...">
                        <div class="media-body">
                          <h3>Tour Operator Name</h3>
                          <h5>Date Posted</h5>
                        </div>
                      </div>                
                    </a>   
                  </div>   
                  <div id="carouselExampleControls1" class="carousel slide" data-ride="carousel">
                      <div class="carousel-inner">
                        <div class="carousel-item active">
                          <img [src]="logoImage" class="d-block w-100 card-img-top" alt="...">
                        </div>
                        <div class="carousel-item">
                          <img [src]="coverImage" class="d-block w-100 card-img-top" alt="...">
                        </div>
                        <div class="carousel-item">
                          <img [src]="logoImage" class="d-block w-100 card-img-top" alt="...">
                        </div>
                      </div>
                      <a class="carousel-control-prev" href="#carouselExampleControls1" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                      </a>
                      <a class="carousel-control-next" href="#carouselExampleControls1" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                      </a>
                    </div>
                  <div class="card-body">
                    <h4 class="card-title">Tour Package Name</h4>
                    <div class="row text-danger">
                      <div class="col-lg-4 col-md-12">
                        Duration
                      </div>
                      <div class="col-lg-4 col-md-12">
                        Location
                      </div>
                      <div class="col-lg-4 col-md-12">
                        Price
                      </div>
                    </div>                
                    <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                    <a (click)="routeToDetailPage(2)" routerLink="" class="btn btn-dark text-white">View Details...</a>
                  </div>
                </div>
          </div>
      </div> -->
        
    </div>
  </div>
</div>
